import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";

const PlanContext = createContext({ has: () => true, planFor: () => null, data: null, reload: () => {}, goPlans: () => {} });

export const PlanProvider = ({ children, goPlans }) => {
  const [data, setData] = useState(null);
  const reload = useCallback(() => api.get("/business/plan").then(({ data }) => setData(data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  const has = (key) => !data || data.my_features.includes(key);
  const planFor = (key) => {
    if (!data) return null;
    return [...data.plans].sort((a, b) => a.monthly_fee - b.monthly_fee).find((p) => (data.plan_features[p.id] || []).includes(key)) || null;
  };
  return <PlanContext.Provider value={{ data, has, planFor, reload, goPlans }}>{children}</PlanContext.Provider>;
};

export const usePlan = () => useContext(PlanContext);
